var matchesImpl;
export default function matches(node, selector) {
  if (!matchesImpl) {
    var body = document.body;
    var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;

    matchesImpl = function matchesImpl(n, s) {
      return nativeMatch.call(n, s);
    };
  }

  return matchesImpl(node, selector);
}


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/matches.js
// module id = 988
// module chunks = 0